export default __webpack_public_path__ + "static/media/COVID_GEN_LINK.cf7c994f.png";